import { useAccount, useMsal } from "@azure/msal-react";

const useUser = () => {
  const { accounts } = useMsal();
  return useAccount(accounts[0] || {});
};

export default useUser;
